import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Grid,
  Divider as MuiDivider,
  Paper,
  Stack,
  Typography,
  Link,
} from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Filters from "./Filters";
import { ChipRed, ChipGreen } from "../services/style";
import { API_BASE_URL } from "../../../config";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

function Accordi() {
  const [loadingPage, setLoadingPage] = useState(true);
  const [allRows, setAllRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtri, setFiltri] = useState({});

  const [pageSize, setPageSize] = useState(5);

  const navigate = useNavigate();

  const columns = [
    {
      field: "tipologia",
      headerName: "Tipologia",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Link
              href={`/pages/accordiDetails/${params.row.iduid}`}
              fontWeight="bold"
            >
              {params.row.nome}
            </Link>
          </Box>
        </>
      ),
    },
    {
      field: "compagnia",
      headerName: "Compagnia",
      minWidth: 350,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "stato",
      headerName: "Stato",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            {params.row.stato === 0 ? (
              <ChipRed label={params.row.statoDesc} />
            ) : (
              <ChipGreen label={params.row.statoDesc} />
            )}
          </Box>
        </>
      ),
    },
    {
      field: "utenteCreatoDa",
      headerName: "Creato da",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">
              {params.row.utenteCreatoDa}
            </Typography>

            <Typography fontSize={10}>{params.row.dataCreazione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "utenteUltimaModifica",
      headerName: "Modificato da",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">
              {params.row.utenteUltimaModifica}
            </Typography>
            <Typography fontSize={10}>
              {params.row.dataUltimaModifica}
            </Typography>
          </Box>
        </>
      ),
    },
  ];

  async function accordiGetList() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          /*  data: {
            idUID: idUID === undefined ? "" : idUID,
          }, */
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/accordiGetList`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      setAllRows(responseData.data.dataset);
      setRows(responseData.data.dataset);
      setFiltri({
        tipologie: responseData.data.tipologie,
        stato: responseData.data.stato,
      });
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  useEffect(() => {
    accordiGetList();
  }, []);

  return (
    <>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Helmet title="Accordi" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              Accordi
            </Typography>
            <Box display="flex" justifyContent="end" gap={4}>
              <Button
                mr={2}
                variant="contained"
                color="primary"
                onClick={() => navigate("/pages/accordiDetails/")}
              >
                <Add />
              </Button>
            </Box>
          </Box>
          <Divider my={4} />
          <Grid container spacing={6}>
            <Grid item xs={12} mb={4}>
              <Filters filtri={filtri} allRows={allRows} setRows={setRows} />
            </Grid>
          </Grid>
          <Card>
            <CardContent pb={1}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography variant="h6" gutterBottom>
                    Risultati: {rows.length}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            <Paper sx={{ width: "100%" }} mt={4}>
              <DataGrid
                columns={columns}
                rows={rows}
                getRowId={(row) => row.iduid}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                pagination
                autoHeight
                disableSelectionOnClick
                components={{
                  NoRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      No rows in DataGrid
                    </Stack>
                  ),
                }}
              />
            </Paper>
          </Card>
        </>
      )}
    </>
  );
}

export default Accordi;
